import { createContext } from "react";
import type { LanguageContextType } from "@/contexts/LanguageContext.types";

export const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);
